import FilterControl from './filtercontrol'

export default FilterControl
